<template>
    <div :class="$style['scroll-box']" ref="scrollBoxRef" data-lenis-prevent>
        <slot></slot>
    </div>
</template>
<script>
import mitt from "mitt";

export default {
  name: "ScrollBox",
  data() {
    return {
      eventBus: mitt(),
    };
  },
  mounted() {
    this.createScrollBox().catch((err) => {
      console.error(err);
    });
  },
  beforeDestroy() {
    this.eventBus.emit("destroy");
    this.eventBus.all.clear();
  },
  methods: {
    async createScrollBox() {
      const { default: ScrollbarCreator } = await import("smooth-scrollbar");
      const scrollbar = ScrollbarCreator.init(this.$refs.scrollBoxRef, {
        alwaysShowTracks: false,
      });

      this.eventBus.on("destroy", () => {
        scrollbar.destroy();
      });
    },
  },
};
</script>
<style lang="scss" module>
.scroll-box {
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden; // smooth-scrollbar 需要容器隐藏原生滚动条
}
</style>
